module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAD1BMVEUAAAD///////////////+PQt5oAAAABHRSTlMAgL9ARyeO/QAAAGNJREFUCNc9jNsNwCAIRS/VAXwNYFoH0MQBxLL/TAU/ekLC5QSA4joOJBJOaJ32EYueaeoK0q6qweflxzJTdxlmXE3szxkDBcYMxNYHcQlRdxlFq8J+dbgXJDGO1HSkJHJn/Hyc0Ql/fwIV3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/Bottom/img4.png
// module id = yxi1
// module chunks = 41